module.exports = {"previous":"&laquo; Précédent","next":"Suivant &raquo;"};